// This list is reused across several code paths to ensure that the shape of the
// data is consistent. This is a partial list of fields; `view` is left out because the response
// from addStatementToTrqkUser will always have `view: null`.
export const statementViewIngestionFields = `
    id
    earnings
    end_date
    name
    normed_statement_url
    performances
    pro
    region
    role_type
    sources
    start_date
    statement_id
    status_name
    status_message
    tracks_this_statement
    unit
    user_id
    version
`;

export const ingestionProgressChunks = {
    upload: 50,
    addStatement: 55,
    checkStatus: {
        ERROR: 0,
        FAILURE: 0,
        PENDING: 60,
        BUILDING: 65,
        ANALYZING: 80,
        RENDERING: 98,
        COMPLETE: 100,
    },
};

export const ingestionProgressChunksV2: Record<string, number> = {
    upload: 50,
    pending: 70,
    processing: 90,
    complete: 100,
};
